'use strict';

function handleUInt8({reader, index, times = 0, quantity = 0, sign, decimal}) {
    for (let i = 1; i <= times; i++) {
        reader.readUInt8InBatch(quantity, `data.sin_${index}.value_${i}`);
    }
    reader.result.set(`data.sin_${index}.times`, times);
}

function handleInt16({reader, index, times = 0, quantity = 0, sign, decimal}) {
    times = times / 2;
    for (let i = 1; i <= times; i++) {
        reader.readInt16LEInBatch(quantity, sign, decimal, `data.sin_${index}.value_${i}`);
    }
    reader.result.set(`data.sin_${index}.times`, times);
}

function handleInt32({reader, index, times = 0, quantity = 0, sign, decimal}) {
    times = times / 4;
    for (let i = 1; i <= times; i++) {
        reader.readInt32LEInBatch(quantity, sign, decimal, `data.sin_${index}.value_${i}`);
    }
    reader.result.set(`data.sin_${index}.times`, times);
}

function handleFloat({reader, index, times = 0, quantity = 0, sign, decimal}) {
    times = times / 4;
    for (let i = 1; i <= times; i++) {
        reader.readFloatLEInBatch(quantity, decimal, `data.sin_${index}.value_${i}`);
    }
    reader.result.set(`data.sin_${index}.times`, times);
}

const REG_TYPE = require('../../../../constant').REG_TYPE;
const timeFilter = require('../../../../../utils/timestamp-util').timestampToDateFilter;

const handle = {
    0: handleUInt8,
    1: handleUInt8,
    2: handleInt16,
    3: handleInt16,
    4: handleInt32,
    5: handleFloat,
    6: handleInt32,
    7: handleFloat,
    8: handleInt16,
    9: handleInt16,
    10: handleInt16,
    11: handleInt16,
};

function parseSingleChannel(reader, index) {
    let length = reader.readUInt8(`data.sin_${index}.length`);
    reader.readUInt32LE(`data.sin_${index}.time_step`);
    let regType = reader.readUInt8(`data.sin_${index}.reg_type`, value => REG_TYPE[value]);
    let quantity = reader.readUInt8(`data.sin_${index}.quantity`);
    let sign = reader.readUInt8(`data.sin_${index}.sign`);
    let decimal = reader.readUInt8(`data.sin_${index}.decimal`);
    let times = quantity === 0 ? 0 : length / quantity;
    handle[regType]({reader, index, times, quantity, sign, decimal});
}

function parse(reader) {
    reader.readUInt32LE("data.timestamp", timeFilter);
    reader.readUInt8("data.mobile_signal");
    reader.readBit(1, "data.din");
    reader.readBit(1, "data.dout");

    let i = 1;
    while (reader.getLength() - reader.getOffset() > 1) {
        parseSingleChannel(reader, i);
        i++;
    }
}

module.exports.parse = parse;
module.exports.parseSingleChannel = parseSingleChannel;



// WEBPACK FOOTER //
// ./src/lib/ucp/parsers/mode/cloud/v1_1/uart/regular-report-parser.js